<!-- Start: Rejwan: 08-04-2026 Early loan settlement -->
<template>
    <b-overlay :show="showoverlaymodal" rounded="sm" class="trz_overlay_custom row">
        <div class="col-sm-12 col-md-12">
            <b-form @submit.stop.prevent="onSubmit">
                <div class="row col-12 no-margin px-0">
                    <!-- Employee Info -->
                    <div class="ibox col-md-12 pf-loan-form no-shadow border">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Employee Info</span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                        <div class="ibox-content px-0">
                            <div class="row text-center">
                                <div class="col-lg-6">
                                    <h3>Employee Name: {{ employee_details.name }}</h3>
                                    <h3>Employee Code: {{ employee_details.code }}</h3>
                                </div>
                                <div class="col-lg-6">
                                    <h3>Date of Joining: {{ employee_details.date_of_joining }}</h3>
                                    <h3>PF Start Date: {{ employee_details.pf_start_date }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Advance Details -->
                    <div class="ibox col-md-12 border-0">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Advance Details</span>
                                <span class="float-right px-3 py-1 border rounded" :style="statusStyle">{{ early_settlement_status }}</span>
                            </h4>
                        </div>
                        <div class="ibox-content px-1 pb-0">
                            <div class="clearfix loan_card_wrapper rounded px-0 col-md-12 pb-0">
                                <div class="row">
                                    <div class="col-sm-6 mt-1 mb-1">
                                        <b-form-group label="Advance Amount" label-for="loan_amount">
                                            <b-form-input id="loan_amount" name="loan_amount" disabled v-model="fdata.loan_amount"></b-form-input>
                                        </b-form-group>

                                        <b-form-group label="Amount Paid" label-for="paid_amount">
                                            <b-form-input id="paid_amount" name="paid_amount" disabled v-model="fdata.paid_amount"></b-form-input>
                                        </b-form-group>
                                    </div>

                                    <div class="col-sm-6 mt-1 mb-1">
                                        <b-form-group label="Interest Amount" label-for="interest_amount">
                                            <b-form-input id="interest_amount" name="interest_amount" disabled v-model="fdata.interest_amount"></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group label="Date" label-for="date_text">
                                            <b-input-group class="mb-3">
                                                <b-form-input id="date_text" name="date_text" v-model="fdata.date" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('date_text')" aria-describedby="date_text-feedback" data-vv-as="Date" disabled></b-form-input>
                                                <b-input-group-append>                                                
                                                    <b-form-datepicker id="date_text" button-only right locale="en-US" v-model="fdata.date" disabled></b-form-datepicker>
                                                </b-input-group-append>
                                                <b-form-invalid-feedback id="date_text-feedback">{{ veeErrors.first('date_text') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>

                                        <b-form-group label="Amount Remaining" label-for="remaining_amount">
                                            <b-form-input id="remaining_amount" name="remaining_amount" :state="validateState('date_text')" v-model="fdata.remaining_amount" disabled></b-form-input>
                                        </b-form-group>
                                    </div>
                                </div>

                                <!-- Attachments & Submit -->
                                <div class="row">
                                    <div class="col-sm-12 mt-1 mb-3 d-flex gap-2">
                                        <a href="javascript:void(0);" class="btn mb-2 btn-secondary d-inline-block px-4 mr-3" @click="showAttachments()">
                                            View Attachments
                                        </a>
                                        <button type="button" v-if="early_settlement_status == 'Pending'" class="btn mb-2 btn-secondary d-inline-block px-4 mr-3"  @click="submitEarlySettlementAction(1)">
                                            Approve
                                        </button>

                                        <button type="button" v-if="early_settlement_status == 'Pending'" class="btn mb-2 btn-secondary d-inline-block px-4 mr-3" @click="submitEarlySettlementAction(2)">
                                            Decline
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </b-form>
        </div>

        <b-modal id="show_attachments" size="lg" hide-footer title="Advance Files" scrollable>
            <pf-loan-documents :pageurl="this.$api_url" flg="1" :is_self="is_self" :key="flg_key" :loan_id="loan_id" type="loan_early_settlement"></pf-loan-documents>
        </b-modal>
    </b-overlay>
</template>

<script>
export default {
    props: ['flg', 'early_settlement_id', 'employee_id', 'employee_name', 'count', 'loan_id', 'early_settlement_status'],

    data() {
        return {
            showoverlaymodal: true,
            flg_key: 0,
            employee_details: {},
            fdata: {
                id: '',
                employee_id: '',
                loan_amount: '',
                paid_amount: '',
                remaining_amount: '',
                interest_amount: '',
                date: null,
                status: '',
            },
        };
    },

    methods: {
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        showAttachments() {
            this.$bvModal.show('show_attachments');
            this.flg_key += 1;
        },

        getEarlySettlmentInfo(loan_id) {
            let url = this.$api_url + '/pf/loan/early-settlement/info'
            this.showoverlaymodal     = true;

            axios.get(url, { params: { early_settlement_id: this.early_settlement_id, loan_id: loan_id, employee_id: this.employee_id } })
                .then((response) => {
                    const data = response.data;
                    this.fdata.id             = data.id;
                    this.fdata.employee_id    = data.employee_id;
                    this.fdata.loan_amount    = this.formatMoney(data.loan_amount);
                    this.fdata.paid_amount    = this.formatMoney(data.paid_amount);
                    this.fdata.interest_amount = this.formatMoney(data.interest_amount);
                    this.fdata.remaining_amount = this.formatMoney(data.remaining_amount);
                    this.fdata.date           = data.date;
                    this.employee_details     = data.employee ?? {};
                    this.showoverlaymodal     = false;
                    
                })
                .catch((error) => {
                    this.showoverlaymodal = false;
                    this.$bvToast.toast('Failed to load advance details.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                    });
                });
        },

        submitEarlySettlementAction(action_type) {
            if (!this.checkNet()) {
                return false;
            }

   
            this.showoverlaymodal = true;


            this.$nextTick(() => {  // ← wait for DOM to update first
                let currentObj = this;
                let url = this.$api_url + '/pf/loan/early-settlement/action';

                let formData = new FormData();
                formData.append('early_settlement_id', this.early_settlement_id);
                formData.append('action_type', action_type);

                axios.post(url, formData)
                    .then((response) => {
                        if(response.data)
                        currentObj.$root.$bvToast.toast(response.data.message, {
                            title: 'Success',
                            variant: response.data.success ? 'success' : 'danger',
                            solid: true,
                            autoHideDelay: 3000
                        });
                        
                        setTimeout(() => {
                            this.showoverlaymodal = false;
                            currentObj.$emit('childToParent');
                        }, 500);
                    })
                    .catch((error) => {
                        const data = error.response?.data;

                        const msg = data?.errors
                            ? Object.values(data.errors).flat()[0]
                            : (data?.error ?? 'Action failed.');

                        currentObj.$root.$bvToast.toast(msg, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true,
                        });
                        this.showoverlaymodal = false;
                    });
            });
        },
    },

    created() {
        if (this.loan_id > 0) {
            this.getEarlySettlmentInfo(this.loan_id);
        } else {
            this.showoverlaymodal = false;
        }
    },

    computed: {
        statusStyle() {
            const colorMap = {
                'Processed': 'green',
                'Declined': 'red',
                'Pending': 'orange',
            };
            const color = colorMap[this.early_settlement_status] || 'orange';
            return {
                border: `1px solid ${color}`,
                color: color,
            };
        }
    }
};
</script>
<!-- End: Rejwan: 08-04-2026 Early loan settlement -->